/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */

/*
 * Il bottone "Resoconto PDF" con le sue tre scelte. Il default e' la versione da
 * consegnare al cliente: importi e foto si', parti interne no.
 */
import { useEffect, useRef, useState } from 'react';
import { FileDown, ChevronDown } from 'lucide-react';
import { apriResoconto } from '../utils/resoconto';

export default function ResocontoButton({ interventoId, codice, compatto = false }) {
  const [aperto, setAperto] = useState(false);
  const [opz, setOpz] = useState({ importi: true, foto: true, interno: false });
  const [inCorso, setInCorso] = useState(false);
  const [errore, setErrore] = useState('');
  const box = useRef(null);

  // Clic fuori: si chiude.
  useEffect(() => {
    if (!aperto) return undefined;
    const fuori = (e) => { if (box.current && !box.current.contains(e.target)) setAperto(false); };
    document.addEventListener('mousedown', fuori);
    return () => document.removeEventListener('mousedown', fuori);
  }, [aperto]);

  const genera = async () => {
    setErrore('');
    setInCorso(true);
    try {
      await apriResoconto(interventoId, codice, opz);
      setAperto(false);
    } catch (e) {
      setErrore(e.message);
    } finally {
      setInCorso(false);
    }
  };

  return (
    <div ref={box} style={{ position: 'relative', display: 'inline-block' }}>
      <button style={compatto ? s.btnCompatto : s.btn} onClick={() => setAperto(!aperto)}>
        <FileDown size={15} /> Resoconto PDF <ChevronDown size={14} />
      </button>
      {aperto && (
        <div style={s.menu}>
          <label style={s.voce}>
            <input type="checkbox" checked={opz.importi} onChange={(e) => setOpz({ ...opz, importi: e.target.checked })} />
            Con prezzi e totale
          </label>
          <label style={s.voce}>
            <input type="checkbox" checked={opz.foto} onChange={(e) => setOpz({ ...opz, foto: e.target.checked })} />
            Con le foto
          </label>
          <label style={s.voce}>
            <input type="checkbox" checked={opz.interno} onChange={(e) => setOpz({ ...opz, interno: e.target.checked })} />
            Versione interna
          </label>
          <div style={s.nota}>
            {opz.interno
              ? 'Aggiunge note interne e nomi degli artigiani esterni: non consegnarla al cliente.'
              : 'Da consegnare al cliente: niente note interne, gli artigiani esterni senza nome.'}
          </div>
          {errore && <div style={s.errore}>{errore}</div>}
          <button style={s.genera} onClick={genera} disabled={inCorso}>
            {inCorso ? 'Preparazione...' : 'Apri il PDF'}
          </button>
        </div>
      )}
    </div>
  );
}

const s = {
  btn: { display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 0.9rem', backgroundColor: 'white', color: '#374151', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '0.86rem', fontWeight: 600, cursor: 'pointer', minHeight: '38px' },
  btnCompatto: { display: 'inline-flex', alignItems: 'center', gap: '0.3rem', padding: '0.35rem 0.6rem', backgroundColor: '#F3F4F6', color: '#374151', border: 'none', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer' },
  menu: { position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 50, width: '270px', backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '10px', boxShadow: '0 10px 25px rgba(0,0,0,0.12)', padding: '0.75rem' },
  voce: { display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.87rem', padding: '0.3rem 0', cursor: 'pointer' },
  nota: { fontSize: '0.76rem', color: '#6B7280', lineHeight: 1.45, margin: '0.4rem 0 0.6rem' },
  errore: { fontSize: '0.8rem', color: '#991B1B', backgroundColor: '#FEE2E2', borderRadius: '6px', padding: '0.4rem 0.5rem', marginBottom: '0.5rem' },
  genera: { width: '100%', padding: '0.55rem', backgroundColor: '#8B5CF6', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '0.88rem', cursor: 'pointer' },
};
